import { useState, useEffect, useRef } from "react";
import * as styled from "./ChatWindowPane.styled";
import MessageBubble from "../../../../components/MessageBubble/MessageBubble";
import axios from "../../../../axios"; 
import { io } from "socket.io-client";
import { useOutletContext, useParams } from "react-router-dom";

export default function ChatWindowPane() {
  const { studentId } = useParams();
  const userData = useOutletContext();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [socket, setSocket] = useState(null);
  const scrollRef = useRef(null);

  // Загрузка сообщений
  useEffect(() => {
    if (!studentId) return;

    const loadMessages = async () => {
      try {
        const res = await axios.get(`/api/messages/chat/${studentId}/${userData._id}`);
        setMessages(res.data);
      } catch (e) {
        console.error(e);
      }
    };

    loadMessages();
  }, [studentId, userData._id]);

  // Подключение к сокету
  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_WS_URL || "http://localhost:4444");
    setSocket(newSocket);

    // Подписываемся на комнату менеджера
    newSocket.emit("joinRoom", `manager_${userData._id}`);

    // Обработка новых сообщений
    newSocket.on("newMessage", (msg) => {
      // Проверяем, что сообщение относится к текущему чату
      if ((msg.senderId === studentId && msg.receiverId === userData._id) || 
          (msg.senderId === userData._id && msg.receiverId === studentId)) {
        setMessages(prev => [...prev, msg]);
      }
    });

    return () => {
      newSocket.disconnect();
    };
  }, [studentId, userData._id]);

  // Автопрокрутка
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    try {
      await axios.post('/api/messages/send', {
        _id: studentId,
        managerId: userData._id,
        text: input.trim()
      });
      setInput("");
    } catch (e) {
      console.error(e);
      alert('Не удалось отправить сообщение');
    }
  };

  if (!studentId) {
    return <styled.Container>Учень не знайдений.</styled.Container>;
  }

  return (
    <styled.Container>
      <styled.MessageList>
        {messages.map((msg) => (
          <MessageBubble
            key={msg._id || msg.timestamp}
            message={msg}
            isOwn={msg.senderRole === "manager"}
          />
        ))}
        <div ref={scrollRef} />
      </styled.MessageList>

      <styled.InputWrapper onSubmit={handleSubmit}>
        <styled.TextInput
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Введіть повідомлення..."
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
        />
        <styled.SendButton type="submit" disabled={!input.trim()}>
          Надіслати
        </styled.SendButton>
      </styled.InputWrapper>
    </styled.Container>
  );
}